import { Box, TableCell, TableHead, TableHeadProps, TableRow, TableSortLabel } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { SortOrder } from "../../utils/sort";
import { TableColumn } from "./EnhancedTable";

export interface EnhancedTableHeadProps {
	columns: TableColumn[];
	orderBy: string;
	sortOrder: SortOrder;
	onRequestSort: (event: React.MouseEvent<unknown>, property: TableColumn) => void;
}

function EnhancedTableHead({ columns, orderBy, sortOrder, onRequestSort }: EnhancedTableHeadProps & TableHeadProps) {
	const createSortHandler = (property: TableColumn) => (event: React.MouseEvent<unknown>) => {
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{columns.map((col) => (
					<TableCell
						key={col.id}
						align={col.align ? col.align : col.numeric ? "right" : "left"}
						sortDirection={orderBy === col.id ? sortOrder : col.defaultSortOrder ?? "asc"}
						sx={col.sx ?? {}}
					>
						{col.sortable ? (
							<TableSortLabel
								active={orderBy === col.id}
								direction={orderBy === col.id ? sortOrder : col.defaultSortOrder ?? "asc"}
								onClick={createSortHandler(col)}
							>
								{col.label}
								{orderBy === col.id ? (
									<Box component="span" sx={visuallyHidden}>
										{sortOrder === "desc" || col.defaultSortOrder === "desc"
											? "sorted descending"
											: "sorted ascending"}
									</Box>
								) : null}
							</TableSortLabel>
						) : (
							col.label
						)}
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

export default EnhancedTableHead;
